import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './Unauthorized.module.css'; // Ensure this file contains the necessary styles

const Unauthorized = () => {
  const navigate = useNavigate();

  const handleLoginRedirect = () => {
    navigate('/login');
  };

  return (
    <div className={styles.unauthorized}>
      <h1 className={styles.title}>403 - Unauthorized</h1>
      <p className={styles.message}>You do not have permission to view this page.</p>
      <button className={styles.button} onClick={handleLoginRedirect}>
        Go to Login
      </button>
    </div>
  );
};

export default Unauthorized;
